import apiService from "./apiService";
import AppConstants from "../appConstants";

class ReportTypeGroupsService {
    getAllReportTypeGroups(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_REPORT_TYPE_GROUPS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getReportTypeGroupDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_REPORT_TYPE_GROUPS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerReportTypeGroup(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_REPORT_TYPE_GROUPS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteReportTypeGroup(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_REPORT_TYPE_GROUPS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_REPORT_TYPE_GROUPS_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ReportTypeGroupsService();
